export type AllowedInterfaceMode = 'default' | 'k5' | 'dfa' | 'ribac';

export function isAllowedInterfaceMode(mode: string): mode is AllowedInterfaceMode {
  return mode === 'dfa' || mode === 'k5' || mode === 'ribac' || mode === 'default';
}
